import { CorrespondenceActionPartyDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CorrespondenceActionPartyService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCorrespondenceActionParty(): Observable<CorrespondenceActionPartyDto[]> {
    return this.http.get<CorrespondenceActionPartyDto[]>(
      this.url + 'correspondence-action-party'
    );
  }

  createCorrespondenceActionParty(
    data: CorrespondenceActionPartyDto[]
  ): Observable<CorrespondenceActionPartyDto[]> {
    return this.http.post<CorrespondenceActionPartyDto[]>(
      this.url + 'correspondence-action-party',
      data
    );
  }
  getSingleCorrespondenceActionParty(id: string): Observable<any> {
    return this.http.get(this.url + 'correspondence-action-party/' + id);
  }

  updateCorrespondenceActionParty(
    data: CorrespondenceActionPartyDto[]
  ): Observable<CorrespondenceActionPartyDto[]> {
    return this.http.post<CorrespondenceActionPartyDto[]>(
      this.url + 'correspondence-action-party/update',
      data
    );
  }

  deleteCorrespondenceActionParty(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('correspondence-action-party', ids.join(', '));
    return this.http.delete(
      this.url + 'correspondence-action-party',
      httpOptions
    );
  }
}
